import { type DatabaseTextValue } from '@databases/types/database';
import { type Cheerio } from 'cheerio';
import { type ParentNode } from 'domhandler';

import { adfDocumentToHtml } from '@canvas/adf/adf-to-html';
import { getAdfTextContentWithUrl } from '@canvas/adf/get-adf-text-content';
import { htmlToAdfDocument } from '@canvas/adf/html-to-adf';

import { getTextContent } from '../../lib/dom';
import { encodeHtml } from '../../utils';

export function renderTextBasedExportView(value: DatabaseTextValue): string {
  const plainHtml = encodeHtml(value.plain).replace(/\r|\n|\r\n/g, '<br/>');
  if (value.rich?.content && value.rich.content.length > 0) {
    const html = adfDocumentToHtml(value.rich);
    return html || plainHtml;
  }
  return plainHtml;
}

export function parseTextBasedFromHtml(el: Cheerio<ParentNode>): DatabaseTextValue {
  const plain = getTextContent(el);
  const html = el.html();
  if (html) {
    const rich = htmlToAdfDocument(html);
    if (rich) {
      return { plain: getAdfTextContentWithUrl(rich, ''), rich };
    }
  }
  return { plain };
}
